import { render, staticRenderFns } from "./ExperimentResult.vue?vue&type=template&id=68f53a3a&"
import script from "./ExperimentResult.vue?vue&type=script&lang=js&"
export * from "./ExperimentResult.vue?vue&type=script&lang=js&"
import style0 from "./ExperimentResult.vue?vue&type=style&index=0&id=68f53a3a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports